import { Injectable, Injector, inject } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { select, Store } from '@ngrx/store';
import { getToken, State } from '../ngrx';
import { Observable, of, throwError } from 'rxjs';
import { catchError, switchMap, take } from 'rxjs/operators';
import { NousToken } from '@app/shared/models/nous-token.model';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  private injector = inject(Injector);
  private router = inject(Router);
  private authService = inject(AuthService);
  private appState$ = inject<Store<State>>(Store);

  readonly token$: Observable<NousToken> = this.appState$.pipe(select(getToken));

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request)
      .pipe(
        catchError((err: HttpErrorResponse) => {
          return this.token$
            .pipe(
              take(1),
              switchMap(token => this.handleError(err, token))
            );
        })
      );
  }

  handleError(err: HttpErrorResponse, token: NousToken) {
    if (!(err instanceof HttpErrorResponse)) {
      return throwError(err);
    }

    if (this.isBadRequest(err)) {
      this.gotToErrorPage();
      return throwError(err);
    }

    if (this.isUnauthorized(err, token)) {
      if (this.isTokenRequest(err)) {
        this.gotToErrorPage('ConfigInterceptor# token error');
        return throwError(err);
      }

      this.refreshToken();
      return of(undefined);
    }

    if (this.isAccessDenied(err)) {
      this.goToAccessDeniedPage();
      return throwError(err);
    }
  }

  isBadRequest(err: HttpErrorResponse): boolean {
    return err.status === 400 && this.hasErrorMessage(err.error.msg);
  }

  hasErrorMessage(msg: any): boolean {
    return msg && (typeof msg === 'string' || Object.keys(msg).length !== 0);
  }

  isUnauthorized(err: HttpErrorResponse, token: NousToken): boolean {
    return token?.accessToken && (err.status === 401);
  }

  isTokenRequest(err: HttpErrorResponse): boolean {
    return err.url.includes('/token');
  }

  isAccessDenied(err: HttpErrorResponse): boolean {
    return err.status === 403;
  }

  refreshToken(): void {
    console.log('ConfigInterceptor login refresh');

    this.authService.getToken(true);
  }

  gotToErrorPage(errorMessage?: string): void {
    if (errorMessage) {
      console.log(errorMessage);
    }

    // Handle error response - set message at error page
    this.router.navigate([ '/error' ]);
  }

  goToAccessDeniedPage(): void {
    // Currently not needed
    // this.router.navigate([ '/accessdenied' ]);
  }
}

